export default "__VITE_ASSET__C0gXDX0e__"